import { Key, RefreshCw, LogOut } from "lucide-react";
import { Button } from "../ui/button";

export function SecuritySection({ onResetPin, onLogout }) {
  return (
    <div className="card-base p-6">
      <h2 className="text-lg font-semibold text-white font-['Outfit'] mb-4 flex items-center gap-2">
        <Key size={20} className="text-indigo-400" />
        Security
      </h2>

      <div className="space-y-4">
        <div className="flex items-center justify-between p-4 rounded-xl bg-slate-800/50">
          <div>
            <p className="text-white font-medium">Family PIN</p>
            <p className="text-sm text-slate-400">
              Change your family access PIN
            </p>
          </div>
          <Button
            variant="outline"
            onClick={onResetPin}
            className="border-slate-700"
            data-testid="reset-pin-button"
          >
            <RefreshCw size={16} className="mr-2" />
            Reset PIN
          </Button>
        </div>

        <div className="flex items-center justify-between p-4 rounded-xl bg-slate-800/50">
          <div>
            <p className="text-white font-medium">Lock App</p>
            <p className="text-sm text-slate-400">
              Return to PIN entry screen
            </p>
          </div>
          <Button
            variant="outline"
            onClick={onLogout}
            className="border-slate-700"
            data-testid="lock-app-button"
          >
            <LogOut size={16} className="mr-2" />
            Lock
          </Button>
        </div>
      </div>
    </div>
  );
}
